import { useFlags } from 'launchdarkly-react-client-sdk';

import { useSpecialsPageSettings } from './use-specials-page-settings';

/**
 * Single source of truth for whether the redesigned specials page (and everything that only
 * exists inside it - category tiles, special duration, menu filter chips, the specials filter
 * sidebar entry, etc.) should render for the current dispensary.
 *
 * Gated on BOTH the LD rollout flag AND the per-dispensary `showSpecialsRedesign` admin toggle
 * (`storeSettings.specialsPage.showSpecialsRedesign`, see `useSpecialsPageSettings`). Reuses that
 * hook rather than re-reading `useDispensary()` directly so there's exactly one place that knows
 * how to read the stored setting.
 */
export function useSpecialsRedesignEnabled(): boolean {
  const flags = useFlags();
  const specialsRedesignFlagEnabled = flags['ecomm.specials-redesign.rollout'] ?? false;
  const { showSpecialsRedesign } = useSpecialsPageSettings();

  return Boolean(specialsRedesignFlagEnabled) && Boolean(showSpecialsRedesign);
}
